import React, { ReactNode } from 'react';

import Text from '../../text/text';

import './lesson-passport__info-item.scss';

interface Props {
    children: ReactNode | ReactNode[];
    label: string;
}

export const LessonPassportInfoItem = React.memo(({ label, children }: Props) => {
    return (
        <div className="lesson-passport__info-item">
            <div className="lesson-passport__info-item-label">
                <Text>{label}</Text>
            </div>
            <div className="lesson-passport__info-item-content">{children}</div>
        </div>
    );
});
